import { useEffect } from 'react';
import { useBlocker, useNavigate } from 'react-router-dom';

export function usePrompt(message: string, disabled: boolean) {
  const navigate = useNavigate();

  const blocker = useBlocker(
    ({ currentLocation, nextLocation }) =>
      disabled && currentLocation.pathname !== nextLocation.pathname
  );

  useEffect(() => {
    if (blocker.state === 'blocked') {
      // eslint-disable-next-line no-alert
      if (window?.confirm(message)) blocker?.proceed?.();
      else blocker?.reset?.();
    } else navigate(blocker?.location?.pathname);
  }, [blocker, navigate, message, disabled]);
}
